export const ITEM_ACTIVITY_ROUTE_BY_OWNER_TYPE = {
  PROPOSAL: (id, isArchived) =>
    `/proposals/${isArchived ? "archived" : "view"}/${id}/general/activity`,
  OPPORTUNITY: (id, isArchived) =>
    `/capture/${isArchived ? "archived-opportunities" : "tracked-opportunities"}/${id}/summary/activity`,
  CONTRACT: (id, isArchived) =>
    `/contracts/${isArchived ? "archived" : "all"}/${id}/summary/activity`,
  MISC_ANALYSIS: (id, isArchived) =>
    `/misc-analysis/${isArchived ? "archived" : "view"}/${id}/general/activity`,
};

export const OWNER_TYPE_SUBTITLE = {
  PROPOSAL: "for this proposal",
  OPPORTUNITY: "for this opportunity",
  CONTRACT: "for this contract",
  MISC_ANALYSIS: "for this analysis",
};

export const ENTITY_TYPE_SUBTITLE = {
  OUTLINE: "in this proposal outline",
  SHRED_REPORT: "in this shred report",
  AMENDMENT: "in this amendment analysis",
  ACRONYM_REPORT: "in this acronym report",
  TECHNICAL_ALIGNMENT: "in this alignment analysis",
  DOCUMENT: "in this item",
};

export const NO_SKIP_NOTE_MESSAGE = "Questions skipped — no note given";

export const CHANGE_ITEM_VARIANT = {
  bullet: "bullet",
  heading: "heading",
  note: "note",
  qa: "qa",
};
